import { attendeeConstants } from "../../../constants/attendee/attendee.constants";
import { alertActions } from "../alert.action";
import { history } from "../../../helpers/history";
import { store } from "../../../store/configureStore";
import { attendeeService } from "../../../services/attendee/attendee.service";
import { authHeader } from "../../../helpers/authHeader";
import { handleResponse } from "../../../helpers/handleresponse";

export const attendeeActions = {
  getOrdersByBadgeNo,
  updateOrder,
  createOrder,
  setPayMethod,
  updateSqlState,
  setActivePersonNo,
  removeOrder,
  updateDiscounts,
  setLeader
};

function setLeader(no) {
  return (dispatch) => {
    dispatch(success(no));
  };
  function success(no) {
    return {
      type: attendeeConstants.SET_LEADER,
      activePersonNo: no,
    };
  }
}

function removeOrder(no) {
  return (dispatch) => {
    dispatch(success(no));
  };
  function success(no) {
    return {
      type: attendeeConstants.REMOVE_ORDER,
      activePersonNo: no,
    };
  }
}

function setActivePersonNo(no) {
  return (dispatch) => {
    dispatch(success(no));
  };
  function success(no) {
    return {
      type: attendeeConstants.SET_ACTIVE_PERSON_NO,
      activePersonNo: no,
    };
  }
}

function getOrdersByBadgeNo(badgeNo) {
  return (dispatch) => {
    dispatch(request({}));
    dispatch(alertActions.clear());
    if (badgeNo) {
      attendeeService.getOrdersByBadgeNo(badgeNo).then(
        (orderList) => {
          dispatch(success(orderList));
        },
        (error) => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
    } else {
      dispatch(success([]));
    }
  };

  function request() {
    return { type: attendeeConstants.GET_ATTENDEE_LIST_REQUEST };
  }
  function success(orderList) {
    return {
      type: attendeeConstants.GET_ATTENDEE_LIST_SUCCESS,
      orderList,
    };
  }
  function failure(error) {
    return {
      type: attendeeConstants.GET_ATTENDEE_LIST_FAILURE,
      error,
    };
  }
}

function createOrder(newOrder) {
  return (dispatch) => {
    dispatch({
      type: attendeeConstants.CREATE_ORDER,
      newOrder,
    });
  };
}
var updateSqlStateTimeout;

function updateDiscounts(discounts, activePersonNo) {
  updateSqlStateTimeout = setTimeout(updateSqlState, 500);
  return (dispatch) => {
    dispatch({
      type: attendeeConstants.UPDATE_DISCOUNT,
      discounts,
      activePersonNo,
    });
  };
}

function updateOrder(updatedOrder, activePersonNo) {
  const form = store.getState().form;
  updatedOrder.sqlStateNo = form.sqlStateNo;
  updatedOrder.formId = form.formId;
  updatedOrder.eventId = form.eventId;
  updatedOrder.languageCode = form.languageCode;
  if (!updatedOrder.orderRow) {
    updatedOrder.orderRow = [];
  }

  console.log(updatedOrder.orderRow)
  //gör clientuträkning
  if (!updatedOrder.orderRow.find((row) => row.eventId === form.eventId)) {
    updatedOrder.orderRow.push({
      amount: form.eventPrice ? form.eventPrice : 0,
      comment: "",
      discount: 0,
      eventId: form.eventId,
      orderId: -1,
      orderRowId: updatedOrder.orderRow.length * -1,
      quantity: 1,
      status: null,
      vatPercent: form.eventVatPercent ? form.eventVatPercent : 0,
      deleted: false,
    });
  }
  if (updateSqlStateTimeout) {
    clearTimeout(updateSqlStateTimeout);
  }
  updateSqlStateTimeout = setTimeout(updateSqlState, 500);

  return (dispatch) => {
    dispatch({
      type: attendeeConstants.UPDATE_ORDER,
      updatedOrder,
      activePersonNo,
    });
  };
}
function updateSqlState() {
  const { attendee, form } = store.getState();

  let storageStates = localStorage.getItem("formstates");
  let formStates = undefined;
  if (storageStates) {
    formStates = JSON.parse(storageStates);
  } else {
    formStates = [];
  }
  var state = formStates.find((fs) => fs.formId === form.formId && fs.expires > Date.now());
  if (state) {
    state.expires = Date.now() + 1800000;
  } else {
    formStates.push({
      formId: form.formId,
      sqlStateNo: form.sqlStateNo,
      expires: Date.now() + 1800000,
    });
  }

  formStates = formStates.filter((fs) => fs.expires > Date.now());
  localStorage.setItem("formstates", JSON.stringify(formStates));
  let body = {
    eventId: form.eventId,
    sqlStateNo: form.sqlStateNo,
    stateString: JSON.stringify(attendee),
  };
  const requestOptions = {
    method: "POST",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify(body),
  };
  fetch(`./api/attendee/`, requestOptions)
    .then(handleResponse)
    .then((isModified) => {
      return isModified;
    });
}
function setPayMethod(payMethod) {
  return (dispatch) => {
    dispatch({
      type: attendeeConstants.SET_PAYMETHOD,
      payMethod,
    });
  };
}
